import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const ExamAttachmentsList = observer(class ExamAttachmentsList extends React.Component {
  extension(filename) {
    let ext = null;

    if(filename) {
      ext = filename.substr(filename.lastIndexOf('.') + 1);
    }

    if(ext) {
      switch (ext) {
        case 'bmp':
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return <icons.icon_image />;

        case 'pdf':
          return <icons.icon_pdf />;

        case 'doc':
        case 'docx':
        case 'txt':
        case 'rtf':
          return <icons.icon_text />;

        case 'xls':
        case 'xlsx':
        case 'csv':
          return <icons.icon_spreadsheet />;

        case 'wma':
        case 'mpg':
        case 'avi':
        case 'flv':
          return <icons.icon_video />;

        case 'mp3':
        case 'ogg':
        case 'wav':
        case 'midi':
          return <icons.icon_audio />;

        case 'zip':
        case 'gz':
        case 'iso':
          return <icons.icon_zip />;

        default:
          return <icons.icon_file />;
      }
    }
  }

  renderResults() {
    const { examConfiguration, translation } = this.props;

    if(typeof examConfiguration.attachments !== 'undefined' && examConfiguration.attachments.length > 0) {
      return (
        <ul className="files panel__files">
          {examConfiguration.attachments.map(
            (key, i) =>
            <li key={i}>
              <a className="files__title" href={key.attachmentUrl} target="_blank">
                {this.extension(key.attachmentAwsTitle)}
                {key.attachmentAwsTitle}
              </a>
            </li>
          )}
        </ul>
      )
    } else {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }
  }

  render() {
    const { translation } = this.props;

    return (
      <section className="panel__section">
        {!this.props.sessionManager &&
          <h2 className="panel__heading">{translation.heading}</h2>
        }

        {this.props.sessionManager &&
          <h4 className="data-heading">{translation.heading}</h4>
        }

        {this.renderResults()}
      </section>
    )
  }
})

export default translate('ExamAttachmentsList')(ExamAttachmentsList);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamAttachmentsList.js